class Main {
  constructor(modules, Utils) {
    this.utils = new Utils()
    this.moduleSelector = 'data-module'
    this.modulesOnPage = document.querySelectorAll(`[${this.moduleSelector}]`)
    this.modulesLoaded = []
    this.modules = modules

    this.inIframe = () => {
      try {
        return window.self !== window.top
      } catch {
        return true
      }
    }

    this.loadModules = () => {
      Array.from(this.modulesOnPage).forEach(element => {
        const moduleInstance = element.getAttribute(this.moduleSelector)

        // ✅ Only skip if module not defined
        if (Object.keys(this.modules).indexOf(moduleInstance) === -1) return

        // ✅ Per-element init flag (instead of blocking all by name)
        if (element.dataset.moduleInitialized === 'true') return
        element.dataset.moduleInitialized = 'true'

        // Lazy-load module file if needed
        if (this.modulesLoaded.indexOf(moduleInstance) === -1) {
          this.modulesLoaded.push(moduleInstance)

          this.modules[moduleInstance]()
            .then(instance => {
              const instanceRef = new instance.default(this.utils)
              instanceRef.init(element)
            })
            .catch(err => {
              console.log(
                'An error occurred while loading the component ' +
                  moduleInstance
              )
              console.error(err)
            })
        } else if (this.inIframe()) {
          // already imported module, just init again for this element
          this.modules[moduleInstance]()
            .then(instance => {
              const instanceRef = new instance.default(this.utils)
              instanceRef.init(element)
            })
            .catch(err => console.error(err))
        }
      })
    }
  }

  init() {
    console.log('HXP Main Init')
    this.loadModules()

    if (this.inIframe()) {
      console.log('(in iframe)')

      // ✅ Observe DOM mutations (existing behavior)
      const observer = new MutationObserver(() => {
        this.modulesOnPage = document.querySelectorAll(
          `[${this.moduleSelector}]`
        )
        this.loadModules()
      })
      observer.observe(document.body, { childList: true, subtree: true })

      // ✅ Also hook into Kentico Page Builder widget events (surgical addition)
      if (window.kentico?.pageBuilder) {
        const reinit = () => {
          this.modulesOnPage = document.querySelectorAll(
            `[${this.moduleSelector}]`
          )
          this.loadModules()
        }

        window.kentico.pageBuilder.on('widget.loaded', reinit)
        window.kentico.pageBuilder.on('widget.updated', reinit)
      }
    }
  }
}

export default Main
